(function () {
    'use strict';

    angular
        .module('franchisee-portal.components')
        .controller('NewsListController', NewsListController);

    /** @ngInject */
    function NewsListController($state, $stateParams, NewsService, AuthenticationService, HelperService) {
        const vm = this;

        let informativesPerPage = 5;
        let informativesSkip = 0;
        let forcePaginationReset = false;
        let isTableSearch = false;

        vm.isSearchDisabled = () => {
            if (vm.datePicker.date.startDate || vm.searchText)
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.datePicker.date.startDate || vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if ((event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;

                vm.getPaginatedInformatives({
                    page: vm.currentPage
                });
            }
        }

        vm.clearSearch = () => {
            vm.datePicker.date.startDate = null;
            vm.datePicker.date.endDate = null;
            vm.searchText = '';

            if (isTableSearch) {
                vm.getPaginatedInformatives({
                    page: vm.currentPage
                });

                isTableSearch = false;
            }
        }

        vm.getPaginatedInformatives = pageData => {
            if (vm.isLoading)
                return;

            if (forcePaginationReset) {
                vm.currentPage = 1;
                forcePaginationReset = false;
            } else
                vm.currentPage = pageData.page;

            informativesSkip = (vm.currentPage - 1) * informativesPerPage;

            getInformatives();
        }

        init();

        function getInformatives() {
            HelperService.startLoading('.news-holder');

            vm.informatives = [];
            vm.isLoading = true;

            const parameters = prepareParameters();
            let userData = AuthenticationService.getUserData();

            NewsService
                .getAllByParameters(parameters, userData.Id)
                .then(success => {
                    vm.informatives = success.Informative;
                    vm.numberOfPages = success.NumberOfPages;
                    vm.isLoading = false;

                    $state.go('app-master.default.news', {
                        newsPage: vm.currentPage
                    });

                    HelperService.stopLoading('.news-holder');
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function prepareParameters() {
            let params = {
                PerPage: informativesPerPage,
                Skip: informativesSkip,
                OrderBy: 'RegistrationDate',
                OrderDescending: true,
                Active: true
            }

            if (vm.datePicker.date.startDate) {
                params.StartDate = vm.datePicker.date.startDate.format('YYYY-MM-DD');
                params.EndDate = vm.datePicker.date.endDate.format('YYYY-MM-DD');
                isTableSearch = true;
            }

            if (vm.searchText) {
                params.SearchField = 'Title';
                params.SearchQuery = vm.searchText;
                isTableSearch = true;
            }

            return params;
        }

        function initVars() {
            vm.currentPage = 1;
            vm.numberOfPages = 0;

            if (isNaN($stateParams.newsPage)) {
                $state.go('app-master.default.news', {
                    newsPage: 1
                });
            } else
                vm.currentPage = $stateParams.newsPage;

            vm.informatives = [];
            vm.isLoading = false;

            vm.datePicker = {
                date: {
                    startDate: null,
                    endDate: null
                },
                options: {
                    'opens': 'left',
                    'timePicker': false,
                    'format': 'DD/MM/YYYY',
                    'ranges': {
                        'Amanhã': [
                            moment().add(1, 'days'),
                            moment().add(1, 'days')
                        ],
                        'Hoje': [
                            moment(),
                            moment()
                        ],
                        'Ontem': [
                            moment().subtract(1, 'days'),
                            moment().subtract(1, 'days')
                        ],
                        '7 Dias': [
                            moment().subtract(7, 'days'),
                            moment()
                        ]
                    },
                    'eventHandlers': {
                        'cancel.daterangepicker': (ev, picker) => {
                            vm.datePicker.date = {
                                startDate: null,
                                endDate: null
                            };
                        }
                    }
                }
            }

            vm.getPaginatedInformatives({
                page: vm.currentPage
            })
        }

        function init() {
            initVars();
        }
    }
}());